import { cn } from '../../lib/utils.js'

function StatsCard({
  className,
  icon,
  label,
  tone = 'default',
  value,
  hint,
}) {
  return (
    <article className={cn('ui-stats-card', `tone-${tone}`, className)}>
      {icon && <span className="ui-stats-card-icon">{icon}</span>}
      <span>{label}</span>
      <strong>{value}</strong>
      {hint && <small>{hint}</small>}
    </article>
  )
}

export { StatsCard }
